/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type PaginationData_pageInfo$ref = any;
type VariantData_variantInfo$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SellingShops_queryResult$ref: FragmentReference;
export type SellingShops_queryResult = {|
  +vendor_variants_search: ?{|
    +related_sorts: $ReadOnlyArray<?{|
      +name: ?string,
      +display_name: ?string,
      +selected: ?boolean,
    |}>,
    +result: ?$ReadOnlyArray<?{|
      +$fragmentRefs: VariantData_variantInfo$ref
    |}>,
    +page_info: ?{|
      +$fragmentRefs: PaginationData_pageInfo$ref
    |},
    +errors: ?$ReadOnlyArray<?{|
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
      +code: ?number,
    |}>,
  |},
  +$refType: SellingShops_queryResult$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SellingShops_queryResult",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "input",
      "type": "VendorVariantsSearchInput",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "vendor_variants_search",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input",
          "type": "VendorVariantsSearchInput"
        }
      ],
      "concreteType": "VendorVariantsSearchResult",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "related_sorts",
          "storageKey": null,
          "args": null,
          "concreteType": "SortOption",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "display_name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "selected",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "result",
          "storageKey": null,
          "args": null,
          "concreteType": "Variant",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "VariantData_variantInfo",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "page_info",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PaginationData_pageInfo",
              "args": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "errors",
          "storageKey": null,
          "args": null,
          "concreteType": "Error",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "field",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "messages",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "code",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5c2fc432ccfe2ab0e7c3db0a846cad83';
module.exports = node;
